'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlHorizontalMouseScroll", function () {
  return {
    restrict: "A",
    link: function link($scope, $el, $attrs) {
      $el.mousewheel(function (e, delta) {
        this.scrollLeft -= delta * 50;
        e.preventDefault();
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/tl/tlHorizontalMouseScroll.js
// module id = 2903
// module chunks = 13